import { GAMES_CONFIGURATION_REDUCER } from '../constants';
import { useCustomSelectorShallow } from './useCustomSelectorShallow';

import { TGamesConfigurationSelector, TEqualityFunction } from '../types';

export const useGameConfigurationSelector = <TSelected>(
    selector: TGamesConfigurationSelector<TSelected>,
    equalityFn?: TEqualityFunction<TSelected>
) => {
    return useCustomSelectorShallow<TSelected, typeof GAMES_CONFIGURATION_REDUCER>(
        GAMES_CONFIGURATION_REDUCER, selector, equalityFn
    );
};
